import { Artboard, PrintPage, ASSETS } from "../components/nk/print/PrintKit";

export default function BusinessCardPage() {
  return (
    <PrintPage
      pageW={106}
      pageH={70}
      title="Business card — 90 × 54 mm"
      subtitle="Front & back · 3 mm bleed + crop marks"
      note="Each side prints on its own page at 90 × 54 mm trim. Choose margins None + Background graphics, or send the PDF straight to your printer."
    >
      {/* FRONT */}
      <Artboard trimW={90} trimH={54} bg="#0A0A0A" testid="card-front">
        <div className="pk-grain h-full w-full flex flex-col items-center justify-center text-ivory text-center" style={{ padding: "7mm" }}>
          <img src={ASSETS.logoLight} alt="NK" style={{ height: "18mm" }} className="w-auto" />
          <p className="text-[8px] uppercase tracking-[0.45em] text-ivory/70 mt-[3.5mm]">NK Bridal Australia</p>
          <p className="font-serif font-semibold italic text-ivory/85 mt-[2mm]" style={{ fontSize: "11pt" }}>Bespoke wedding gowns</p>
        </div>
      </Artboard>

      {/* BACK */}
      <Artboard trimW={90} trimH={54} bg="#FDFBF7" testid="card-back">
        <div className="pk-grain h-full w-full flex" style={{ padding: "7mm" }}>
          <div className="flex flex-col justify-between h-full">
            <div>
              <img src={ASSETS.logoDark} alt="NK" style={{ height: "12mm" }} className="w-auto" />
              <p className="font-serif font-semibold text-ink mt-[3mm]" style={{ fontSize: "13pt", lineHeight: 1 }}>Nancy Khau</p>
              <p className="text-[8px] uppercase tracking-[0.3em] text-ink/90 mt-[1.5mm]">Designer &amp; Founder</p>
            </div>
            <div className="space-y-[1.2mm]">
              <p className="text-ink" style={{ fontSize: "10pt" }}>0433 601 060</p>
              <p className="text-ink" style={{ fontSize: "8.5pt" }}>nkbridalaustralia@gmail.com</p>
              <p className="text-ink" style={{ fontSize: "8.5pt" }}>nkbridalaustralia.com.au</p>
              <p className="text-[7.5px] uppercase tracking-[0.25em] text-ink/90 pt-[1mm]">Perth · Australia-wide · @nkbridalaustralia</p>
            </div>
          </div>
        </div>
      </Artboard>
    </PrintPage>
  );
}
